import { Card, Divider, Flex, Group, Stack, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { MotilityAnalysis } from "types/testTypes";
import { MOTILITY_TR } from "../../result/utils/motilityPresentation";
import GazePositionGrid from "./GazePositionGrid";
import { MotilityFindingsList, MotilityWarnings } from "./MotilityFindings";
import { InfoHint } from "./MotilitySectionHeading";

/**
 * The nine-position grid, with everything read once per test rather than once per
 * position standing beside it at the same height.
 */
interface MotilityMuscleReportProps {
  analysis: MotilityAnalysis;
}

export default function MotilityMuscleReport({ analysis }: MotilityMuscleReportProps) {
  const { t } = useTranslation();

  return (
    <Card withBorder radius="md" p="md" h="100%">
      <Stack gap="sm">
        <Group justify="space-between" align="center" gap="xs" wrap="wrap">
          <Group gap={6} wrap="nowrap">
            <Title order={5}>{t(`${MOTILITY_TR}.title`)}</Title>
            <InfoHint label={t(`${MOTILITY_TR}.helper`)} />
          </Group>
          <MotilityWarnings warnings={analysis.warnings} />
        </Group>

        <Divider />

        <Flex gap="lg" align="stretch" wrap="wrap">
          {analysis.gazeGrid && <GazePositionGrid analysis={analysis} />}
          <Flex style={{ flex: "1 1 260px", minWidth: 240 }}>
            <MotilityFindingsList analysis={analysis} />
          </Flex>
        </Flex>
      </Stack>
    </Card>
  );
}
